import { keyframes } from '@planne-software/uni/mui/material';

export const overlayFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const modalPanelEnter = keyframes`
  0% { opacity: 0; transform: translateY(40px) scale(0.82); }
  60% { opacity: 1; transform: translateY(-6px) scale(1.02); }
  80% { transform: translateY(3px) scale(0.99); }
  100% { opacity: 1; transform: none; }
`;

export const modalDrawerSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const heroGradientShift = keyframes`
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
`;

export const cardPulse = keyframes`
  0%, 100% {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(87, 227, 164, 0.6);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08), 0 0 0 14px rgba(87, 227, 164, 0);
    transform: scale(1.018);
  }
`;
